import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hello Again, I am <span className="purple">Eliyas Asefa </span>
            from <span className="purple"> Ethiopia, Addis Ababa.</span>
            <br /> I am a Software Engineering BSc Graduate from Addis Ababa
            Science and Technology University.
            <br />
            I am currently employed as a software Engineer at West International
            Holdings Africa.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Designing
            </li>
            <li className="about-activity">
              <ImPointRight /> Drawing and Sketching
            </li>
            <li className="about-activity">
              <ImPointRight /> AI
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Our environment is but a mere reflection of who we truly are!"{" "}
          </p>
          <footer className="blockquote-footer">Eliyas</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
